import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import AdminSidebar from "./components/Sidebar";
import Header from "./components/Header";
import { useParams } from "react-router-dom";
import apiClient from "../../api/clinet";

interface Props {}
const EditPatient: React.FC<Props> = (Props) => {
  let { id } = useParams();
  const [initialName, setInitialName] = useState("");
  const [InitialFatherName, setInitialFatherName] = useState("");
  const [initialPatientId, setInitialPatientId] = useState<number>(0);
  const [initialPhoneNumber, setInitialPhoneNumber] = useState<number>(0);
  useEffect(() => {
    apiClient.get(`/patients/${id}`).then((patientData) => {
      setInitialName(patientData.data.name);
      setInitialFatherName(patientData.data.fatherName);
      setInitialPatientId(patientData.data.patientId);
      setInitialPhoneNumber(patientData.data.phoneNumber);
    });
  }, []);
  const initialValues = {
    name: initialName,
    fatherName: InitialFatherName,
    patientId: initialPatientId,
    phoneNumber: initialPhoneNumber,
  };
  const validationSchema = Yup.object().shape({
    name: Yup.string().min(3, "کوتاه است").max(15).required(),
    fatherName: Yup.string().min(3, "کوتاه است").max(15),
    patientId: Yup.string().min(4).max(20).required(),
    phoneNumber: Yup.string().min(4).max(20).required(),
  });

  interface Ipatient {
    name: string;
    phoneNumber: number;
    patientId: number;
    fatherName: string;
    id: number;
  }
  const onSubmit = (data: Ipatient) => {
    try {
      apiClient.put(`/patients/${id}`, data).then(() => {});
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="createPostPage">
      <AdminSidebar />

      <div className="leftColumnPatients" id="addContainer">
        <Header />
        <Formik
          initialValues={initialValues}
          enableReinitialize
          onSubmit={onSubmit}
          validationSchema={validationSchema}
        >
          <Form className="formContainerCrud">
            <label className="crudLabel">:اسم</label>
            <ErrorMessage name="name" component="span" />
            <Field
              autoComplete="off"
              id="inputCreatePost"
              name="name"
              placeholder="(Ex. John123...)"
            />
            <label className="crudLabel" style={{ display: "block" }}>
              اسم پدر:
            </label>
            <ErrorMessage name="fatherName" component="span" />
            <Field
              autoComplete="off"
              id="inputCreatePost"
              name="fatherName"
              placeholder="(Ex. John123...)"
            />

            <label className="crudLabel">کد ملی:</label>
            <ErrorMessage name="patientId" component="span" />
            <Field
              autoComplete="off"
              type="number"
              id="inputCreatePost"
              name="patientId"
              placeholder="Your patientId..."
            />
            <label className="crudLabel">شماره تلفن</label>
            <ErrorMessage name="phoneNumber" component="span" />
            <Field
              autoComplete="off"
              type="number"
              id="inputCreatePost"
              name="phoneNumber"
              placeholder="Your phoneNumber..."
            />

            <button type="submit" className="SubmitButton">
              {" "}
              Edit Patient
            </button>
          </Form>
        </Formik>
      </div>
    </div>
  );
};

export default EditPatient;
